import React from 'react'
import { LabeledSelect } from '@apex/component-library'
import { Box } from '@chakra-ui/react'
import {
  emptyTransferTypeOption,
  achTypeOption,
  cashJournalTypeOption,
  wireTypeOption,
  checkTypeOption,
  positionJournalTypeOption
} from '../../utils/optionBuilders'
import { MAX_COLUMN_WIDTH, COLUMN_WIDTH } from '../../utils'
import useAuth from '../../hooks/useAuth'

export enum TransferSelectEnum {
  Empty = 'empty',
  ACH = 'ach',
  CashJournal = 'cj',
  Wire = 'wire',
  Check = 'check',
  PositionJournal = 'pj'
}
interface TransferSelectProps {
  handleTransferSelectionChange: (value: TransferSelectEnum) => void
  selectValue: TransferSelectEnum
  permissions: {
    hasAch: boolean
    hasCashJournal: boolean
    hasWire: boolean
    hasCheck: boolean
    hasPositionJournal: boolean
  }
}

export const TransferSelect = ({ handleTransferSelectionChange, selectValue, permissions }: TransferSelectProps) => {
  const { featureFlag } = useAuth()
  const { hasAch, hasCashJournal, hasCheck, hasPositionJournal, hasWire } = permissions
  const transferTypeOptions = [
    emptyTransferTypeOption,
    ...(hasAch ? [achTypeOption] : []),
    ...(hasCashJournal ? [cashJournalTypeOption] : []),
    ...(hasWire ? [wireTypeOption] : []),
    ...(hasCheck ? [checkTypeOption] : []),
    ...(hasPositionJournal && featureFlag.positionJournal ? [positionJournalTypeOption] : [])
  ]

  return (
    <Box>
      <Box width={COLUMN_WIDTH} maxW={MAX_COLUMN_WIDTH}>
        <LabeledSelect
          aria-label='Select Transfer Type'
          label='Transfer Type'
          name='transferType'
          isRequired
          value={selectValue}
          onChange={(e) => {
            handleTransferSelectionChange(e.target.value as TransferSelectEnum)
          }}
        >
          {transferTypeOptions.map((option) => (
            <option key={option.key} value={option.value}>
              {option.text}
            </option>
          ))}
        </LabeledSelect>
      </Box>
    </Box>
  )
}
